<template>
  <ValidationProvider
    v-slot="{ errors, valid, validated }"
    :name="name"
    :rules="getValidation"
    slim
  >
    <basic-form-group
      :id="id"
      :label="$attrs.label"
      :hint="$attrs.hint"
      :label-is-up="labelIsUp"
      :required="$attrs.required"
      :horizontal="$attrs.horizontal"
    >
      <div class="input-group">
        <input
          :id="id"
          v-model.lazy="date"
          v-validate="getValidation"
          v-bind="$attrs"
          :class="{'is-invalid': veeFields[veeField] && veeFields[veeField].validated && veeFields[veeField].invalid, 'form-control-sm': sm}"
          :name="veeField"
          :data-vv-as="name"
          class="form-control"
          type="text"
        >
        <div
          v-if="!$attrs.disabled"
          class="input-group-append"
        >
          <transition name="slide-fade">
            <div
              v-if="isOpen"
              class="calendar-wrapper left"
            >
              <div class="card mt-1 shadow-sm">
                <div class="card-body">
                  <datepicker
                    :id="'datepicker-'+id"
                    v-model="datepickerDate"
                    :language="de"
                    class="datepicker"
                    :class="{ 'form-control-sm': sm }"
                    inline
                    :disabled-dates="disabledDates"
                    :name="'datepicker-'+veeField"
                    @selected="isOpen = false"
                  />
                </div>
              </div>
            </div>
          </transition>
          <button
            type="button"
            class="btn btn-primary"
            :class="{ 'btn-sm': sm }"
            @click="isOpen = !isOpen"
            @blur="isOpen = false"
          >
            <i class="fas fa-calendar-alt" />
          </button>
        </div>
      </div>
    </basic-form-group>
  </ValidationProvider>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { de } from 'vuejs-datepicker/dist/locale'
import basicComponentMixin from './basic-component-mixin.js'
import moment from 'moment'

export default {
  name: 'BasicDatepicker',
  components: {
    Datepicker
  },
  mixins: [basicComponentMixin],
  props: {
    disabledDates: {
      type: Object,
      default: () => ({}),
      required: false
    },
    format: {
      type: String,
      required: false,
      default: 'DD.MM.YYYY'
    },
    sm: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: false,
      de
    }
  },
  computed: {
    date: {
      get () {
        if (!this.model) return this.model
        return moment(this.model).format(this.format)
      },
      set (dateStr) {
        this.model = this.parseDate(dateStr)
      }
    },
    datepickerDate: {
      get () {
        return this.model
      },
      set (date) {
        this.model = moment(date).startOf('day').toDate()
      }
    }
  },
  methods: {
    parseDate (dateStr) {
      const parsed = moment(dateStr, this.format)
      if (parsed.isValid()) {
        return parsed.toDate()
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.calendar-wrapper {
  z-index: 1000;
  position: absolute;
  bottom: 0;
  transform: translateY(100%);
  &.left{
    right: 0;
  }
}

.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all 200ms ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(90%);
  opacity: 0;
}
.datepicker ::v-deep {
  .vdp-datepicker__calendar {
    border: none
  }
  .cell.today {
    background-color: #cae5ed
  }
}
</style>
